import {FETCH_COURSE_MATERIAL} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_COURSE_MATERIAL:
            return action.payload;
        default:
            return state;
    }
};